// NOTE: These are already available directly on components defined using defineElement.
export const patterns = {
    email: "^[^@]+@[^@]+$",
    password: "^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).*$",
    username: "^[a-z0-9]+[-.a-z0-9_]*[a-z0-9]$",
    phone: "^\\s*[+]?([\\d\\)\\(]+\\s?[\\-\\.]?\\s?)+\\d+\\s*$",
    phoneAllowed: "[-\\+\\.\\d\\s\\)\\(]",
    date: "^\\d{4}\\/\\d{1,2}\\/\\d{1,2}$",
    dateAllowed: "[-/\\d]",
    currency: "^\\d*\\.?\\d*$",
    currencyAllowed: "[\\d\\.]",
    currencyWithCommas: "^\\d*(,\\d{3})*\\.?\\d*$"
};